import { useAuthentication } from '@connected/api-client/hooks/use-authentication';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SubmenuNavigation } from '@/components/submenu-navigation';

export const Route = createFileRoute('/_auth/dashboard/account/$userId')({
    component: RouteComponent,
    staticData: {
        theme: 'electrical',
    },
});

function RouteComponent() {
    const { t } = useTranslation('dashboard');
    const params = Route.useParams();
    const auth = useAuthentication();
    return (
        <div className="flex flex-col gap-4 m-4">
            {/* title */}
            <div className="text-2xl font-semibold">
                <h1>{t('dashboard.account.settings.title')}</h1>
            </div>
            <div className="w-full mx-auto">
                <SubmenuNavigation
                    items={[
                        {
                            label: t('dashboard.account.settings.tabs.profile-settings'),
                            to: '/dashboard/account/$userId/profile',
                            params,
                        },
                        ...(!auth?.currentUser?.IsAdmin
                            ? [{
                                    label: t('dashboard.account.settings.tabs.security-settings'),
                                    to: '/dashboard/account/$userId/security' as const,
                                    params,
                                }]
                            : []
                        ),
                    ]}
                />
                <Outlet />
            </div>
        </div>
    );
}
